import { render } from "./ImmunizationRegister.vue?vue&type=template&id=0a7be7a4&scoped=true"
import script from "./ImmunizationRegister.vue?vue&type=script&lang=js"
export * from "./ImmunizationRegister.vue?vue&type=script&lang=js"

import "./ImmunizationRegister.vue?vue&type=style&index=0&id=0a7be7a4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7be7a4"]])

export default __exports__